export default "__VITE_ASSET__D9pSd$GI__"